import { promptSlugStatuses, type PromptSlugStatus } from '@flintmint/core-shared/medical-note';
import { getFunctionsUrl } from '@flintmint/web-shared/utils/get-functions-url';

import { ENVIRONMENT } from '@/constants';

// Above the backend's own 5s Braintrust timeout, so a slow Braintrust still answers 'unknown' from there.
const CHECK_TIMEOUT_MS = 10_000;

/**
 * Asks the backend whether a prompt slug resolves in its Braintrust environment. Any failure of the
 * check itself is 'unknown', which callers must treat as "don't block the save".
 */
export async function checkPromptSlug(slug: string, accessToken: string | null): Promise<PromptSlugStatus> {
  if (!accessToken) return 'unknown';

  try {
    const response = await fetch(`${getFunctionsUrl('tiptapAgent', ENVIRONMENT)}/prompt-exists/${encodeURIComponent(slug)}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
      signal: AbortSignal.timeout(CHECK_TIMEOUT_MS),
    });
    if (!response.ok) {
      console.warn('Prompt slug check failed', { slug, status: response.status });
      return 'unknown';
    }

    const body = (await response.json()) as { status?: unknown };
    return promptSlugStatuses.find((status) => status === body.status) ?? 'unknown';
  } catch (error) {
    console.warn('Prompt slug check failed', { slug, error: String(error) });
    return 'unknown';
  }
}
